<template>
   <div class="modal fade" id="mdNewContent" tabindex="-1" aria-labelledby="mdNewContentLabel" aria-hidden="true">
      <div class="modal-dialog modal-fullscreen-md-down">
         <div class="modal-content">
            <!--
            {{cellId}},{{cellName}}
            <br>
            {{dataToAdd}}
            -->
            <div class="modal-body bg-l-gray pt-0">
               <div v-if="dataToAdd.frontPageColor" class="row rw-1 fp-height"
                        :style="{'background-color': dataToAdd.frontPageColor}"
                        >
               </div>
               <div class="row pt-2">
                  <div class="col-1">
                     <font-awesome-icon icon="money-check" /> 
                  </div>
                  <div class="col-10 p-0">
                     <div v-if="!editTitle" id="div-add-title" class="col-12" @click="editTitleIn()">
                        <h6 class="text-break"><b>{{dataToAdd.title}}</b></h6>
                     </div>
                     <div v-else class="col-12">
                        <textarea 
                           id="ta-add-title"
                           ref="ta_title"
                           v-model="dataToAdd.title"
                           class="form-control fw-ttl p-0" 
                           rows="1" 
                           @blur="editTitleOut()"
                           @keyup="resizeTaTitle"
                        ></textarea>
                     </div>
                  </div>
                  <div class="col-1 d-flex justify-content-end">
                     <button type="button" class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
               </div>
               <div class="row pt-0">
                  <div class="col-1">
                     <CardRectangle :rectangleCard="dataToAdd" />
                  </div>
                  <div class="col-10 p-0">
                     <div class="col-12 tc-gray fs-13">en la lista <b><i>{{cellName}}</i></b></div>
                     <div class="col-12">
                        &nbsp;
                     </div>
                  </div>
               </div>
            </div>
            <!-- llamada al modal del contenido -->
            <button v-show="false" 
               type="button" class="btn btn-sm btn-card"  
               data-bs-toggle="modal" data-bs-target="#mdContent" 
               :data-cntt-id="contentId" 
               :data-cell-id="cellId"
               :data-cellContent-id="cellContentId"
               ref="btnEdit"
            >
            </button>
            <!--
            {{currentUserId}}
            <br>
            {{boardId}}
            -->
         </div>
      </div>
   </div>
</template>

<script>
import { ref, onMounted, nextTick, computed } from 'vue';
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

import CardRectangle from "./CardRectangle.vue";

export default {
   components: {
      CardRectangle
   },
   setup() {

      const boardId = ref(0)
      const cellId = ref(0)
      const cellName = ref("")
      const contentId = ref(0)
      const cellContentId = ref(0)
      const dataToAdd = ref({})
      const defaultTitle = ref("")
      const editTitle = ref(false)
      const btnEdit = ref(null)

      const store = useStore()
      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      onMounted(() => {
         document.getElementById('mdNewContent')
         .addEventListener('shown.bs.modal', function (event) {
            let button = event.relatedTarget
            //cardTypeId.value = button.getAttribute('data-card-type-id')
            let cardTypeId = button.getAttribute('data-card-type-id')
            cellId.value = button.getAttribute('data-cell-id')
            cellName.value = button.getAttribute('data-cell-name')
            boardId.value =  button.getAttribute('data-board-id')
            //console.log('md new --> data-card-type-id: ' + cardTypeId.value);
            //console.log('md new --> data-cell-id: ' + cellId.value);
            getDataToAddContent(cardTypeId)
            nextTick(() => {
            //editTitleIn()
               document.getElementById('div-add-title').click()
            })
         })
         console.log('mounted the md new')
      })

      function editTitleIn() {
         editTitle.value = true
         nextTick(() => {
            //let taAddTitle = document.getElementById('ta-add-title')
            //console.log(defaultTitle.value)
            document.getElementById('ta-add-title').focus()
            document.getElementById('ta-add-title').dispatchEvent(new Event("keyup"))
         })
      }
      
      function editTitleOut() {
         let addTitle = document.getElementById('ta-add-title').value.trim()
         console.log(addTitle)
         if (defaultTitle.value != addTitle) {
            console.log(cellId.value+','+currentUserId.value+',0,'+addTitle+','+boardId.value)
            WspService.addContent(
               currentUserId.value, // userId,
               boardId.value,       // boardId, 
               cellId.value,        // cellId,
               dataToAdd.value.id,  // cardTypeId,
               addTitle             // title
               )
            .then(response => {
               contentId.value = response.data
               console.log("addContent Id: " + contentId.value)
               if (contentId.value > 0) {
                  WspService.getCellContent(cellId.value, contentId.value)
                  .then(response => {
                     console.log(response.data.id);
                     cellContentId.value = response.data.id
                     nextTick(() => { btnEdit.value.click() })
                  })
                  .catch(error => {
                     console.log(error);
                  });
                  //nextTick(() => { btnEdit.value.click() })
               } else {
                  dataToAdd.value.title = defaultTitle.value
               }
            })
            .catch(error => {
               console.log(error);
            });
         }
         editTitle.value = false
      }

      function getDataToAddContent(cardTypeId) {
         WspService.getDataToAddContent(cardTypeId)
         .then(response => {
            dataToAdd.value = response.data
            //console.log("dataToAdd: " + dataToAdd.value)
            if (dataToAdd.value.title == null)
               dataToAdd.value.title = "Ingresar un titulo..."
            defaultTitle.value = dataToAdd.value.title
         })
         .catch(error => {
            console.log(error);
         });
      }

      return {
         boardId,
         btnEdit, editTitle, editTitleIn, editTitleOut,
         cellId, cellName, cellContentId,
         contentId,
         currentUserId,
         dataToAdd         
      }
   }
}
</script>

<style scoped>
.fp-height {
   height: 116px;
}
.bg-l-gray {
   background-color:  #ecf0f1 ;
}
.tc-gray {
   color: gray;
}
.fs-13 {
   font-size: 13px;
}
.fw-ttl {
   font-weight: 700;
}
@media (min-width: 768px) {
   .modal-dialog {
      min-width: 768px;
   }
   .dsply-in {
      display: none;
   }
}
@media (max-width: 767px) {
   .dsply-out {
      display: none;
   }
}
</style>